module.exports = __webpack_public_path__ + "AKL.170395ef.atlas";